import React, { useEffect, useRef, useState } from "react";
import { Box, InputLabel, Typography, styled } from "@mui/material";
import Iconify from "../iconify/iconify";

const StyledWrapperBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  padding: "10px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  minWidth: "100px",
  justifyContent: "space-between",
  background: theme.palette.background.main,
  color: theme.palette.text.primary,
}));

const StyledMenuBox = styled(Box)(({ theme }) => ({
  top: "100%",
  left: 0,
  width: "100%",
  borderRadius: "4px",
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.grey[800],
  color: theme.palette.text.secondary,
}));
const StyledItemMenuBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
  padding: "10px",
  cursor: "pointer",
  background: theme.palette.background.default,
  "&:hover": {
    background: theme.palette.grey[800],
  },
}));

const StyledArrowBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "25px",
  height: "25px",
  borderRadius: "50%",
  background: theme.palette.background.main,
  color: theme.palette.text.secondary,
}));
const CustomSelectLng = ({
  data = [],
  placeholder,
  defaultChecked,
  onChange = () => {},
  isError = false,
  errorMsg = "",
  disabled = false,
  isSelect = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    defaultChecked || undefined
  );

  const selectRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = ({ label, value }) => {
    console.log(label);
    console.log(value);
    setSelectedOption(label);
    setIsOpen(false);

    onChange(value);
  };

  return (
    <Box width="100%">
      <Box ref={selectRef} width="100%">
        <StyledWrapperBox onClick={toggleOpen}>
          <Typography variant="subtitle2">
            {!!selectedOption ? selectedOption : placeholder}
          </Typography>
          <StyledArrowBox>
            <Iconify
              icon={isOpen ? "ep:arrow-down-bold" : "ep:arrow-up-bold"}
              sx={{ width: "15px", height: "15px" }}
            />
          </StyledArrowBox>
        </StyledWrapperBox>
        {isOpen && (
          <StyledMenuBox>
            {data.map((item, index) => (
              <StyledItemMenuBox
                key={index}
                onClick={() => handleOptionClick(item)}
              >
                {!!item.img ? (
                  <img
                    style={{
                      width: "25px",
                      height: "25px",
                    }}
                    src={item.img}
                    alt="google-translate"
                  />
                ) : null}

                <Typography variant="body1">{item.label}</Typography>
              </StyledItemMenuBox>
            ))}
          </StyledMenuBox>
        )}
      </Box>
      {isError && <Typography color="error">{errorMsg}</Typography>}
    </Box>
  );
};

export default CustomSelectLng;
